import React, { useState } from "react";
import ReviewDone from "./ReviewDone";
import ReviewPage from "./ReviewPage";

const  Review = () => {
  const [reviewUploaded, setReviewUploaded] = useState(false);

  return (
    <div className="container">
      {
        reviewUploaded ? 
          <ReviewDone/>
        :<ReviewPage setReviewUploaded={setReviewUploaded} />
      }
    </div>
  );
};

export default Review;
